@import 'node_modules/@gaiads/telia-react-component-library/build/styles/colors';
@import '../breakpoints';

$loginMaxWidth: 532px;

.login {
  background-color: color(white);

  &_heading {
    display: block;
    padding: 24px 24px 32px;

    @include to('md') {
      font-size: 24px;
    }

    @include from('md') {
      max-width: $loginMaxWidth;
      padding: 41px 0 36px;
      margin: 0 auto;
    }
  }

  &_tabs__container {
    @include to('md') {
      padding: 0 24px;
    }

    @include from('md') {
      max-width: $loginMaxWidth;
      margin: 0 auto;
    }
  }

  &_additionalLinkContent {
    @include to('md') {
      padding: 15px 24px;
    }

    @include from('md') {
      max-width: $loginMaxWidth;
      margin: 0 auto;
      padding: 15px 0px;
    }
  }
}
